import React from "react";
import { useDispatch } from "react-redux";
import { UPDATE_VARIABLE_TP } from "../../../../actions/create-bot-type";
import { Button } from "react-bootstrap";
import { isLong } from "../../../../utils/Utils";

const VariableTP = (props) => {
  const { newBot } = props;
  const tps = newBot.variableTP;
  const long  = isLong(newBot.strategy)
  const dispatch = useDispatch();
  const updateTP = (list) => {
    let total = list.reduce((n, {stopAt}) => n + parseInt(stopAt), 0)
    if(total<=100){
      dispatch({
        type: UPDATE_VARIABLE_TP,
        payload: list,
      });
    }
    
  };

  const addVariabletSL = () => {
    updateTP([...tps, { triggerAt: 2, stopAt: 1 }]);
  };
  const tslItems = tps.map((item, id) => {
    const changeStopAt = (val) => {
      
      const tempTsl = [...tps];
      const trailing = tempTsl[id];
      trailing.stopAt = val;
      updateTP(tempTsl);
    };

    const changeTriggerAt = (val) => {
      const tempTsl = [...tps];
      const trailing = tempTsl[id];
      trailing.triggerAt = val;
      updateTP(tempTsl);
    };

    const deleteTP = () => {
      updateTP(tps.filter((_, index) => index !== id));
    };
    return (
      <div key={id} className="trailing-item">
        <i
          className="fas fa-trash-alt text-danger"
          style={{ marginRight: 10, fontSize: 13 }}
          onClick={deleteTP}
        ></i>
        {id + 1}. {long?"Sell":"Buy"} {" "}
        <input
          type="number"
          style={{ width: 50 }}
          value={item.stopAt}
          onChange={(e) => changeStopAt(e.target.value)}
          min={0}
        />
        % of asset when price hits{" "}
        <input
          type="number"
          style={{ width: 50 }}
          value={item.triggerAt}
          onChange={(e) => changeTriggerAt(e.target.value)}
          min={0}
        />
        % {long?"above":"below"} {long?"Buy":"Sell"} Price
      </div>
    );
  });
  return (
    <div>
      {tslItems}
      {tslItems.length <= 9 && (
        <div>
          <Button onClick={addVariabletSL} variant="success">
            Add
          </Button>
        </div>
      )}
    </div>
  );
};

export default VariableTP;
